<template>
  <HrPageLayout
    title="Pending Approvals"
    subtitle="Pending Approvals-data edits"
    :breadcrumb-items="[
      { label: 'Home', route: '/dashboard' },
      { label: 'Employee Approvals' },
      { label: 'Pending Approvals-data edits' }
    ]"
  >
    <div class="edit-approvals-content">
      <div class="hr-chart-card">
        <div class="hr-chart-body">
          <div class="hr-table-wrapper">
            <table class="hr-table hr-table-hover hr-table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Field(s) Edited</th>
                  <th>Edited By</th>
                  <th>Edited Date</th>
                  <th>Reason for Edit</th>
                  <th>Net Salary After Edit</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in employeeDataEdits" :key="index">
                  <td>{{ formatDate(item.dateCreated) }}</td>
                  <td>{{ getFormattedChangedFields(item.previousData, item.newData) }}</td>
                  <td>{{ item.createdBy }} <span v-if="item.submittingOfficerRole">({{ item.submittingOfficerRole }})</span></td>
                  <td>{{ formatDate(item.dateCreated) }}</td>
                  <td>{{ item.reason || 'Employee data update' }}</td>
                  <td>{{ getNetSalaryAfterEdit(item.newData) }}</td>
                  <td>
                    <button class="hr-btn hr-btn-sm hr-btn-primary" @click="viewEditDetails(item)" data-bs-toggle="modal" data-bs-target="#editLogModal">
                      <i class="bx bx-show"></i> View Details
                    </button>
                  </td>
                </tr>
                <tr v-if="employeeDataEdits.length === 0">
                  <td colspan="7" class="hr-text-center hr-text-muted">No pending approvals found.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Edit Log Modal -->
                      <div class="modal fade" id="editLogModal" tabindex="-1" aria-labelledby="editLogModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="editLogModalLabel">Edit Log Details</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
                            </div>
                            <div class="modal-body" v-if="selectedEdit">
                              <p><strong>Edited By:</strong> {{ selectedEdit.createdBy }} <span v-if="selectedEdit.submittingOfficerRole">({{ selectedEdit.submittingOfficerRole }})</span></p>
                              <p><strong>Edited Date:</strong> {{ formatDate(selectedEdit.dateCreated) }}</p>
                              <p><strong>Reason for Edit:</strong> {{ selectedEdit.reason || 'Employee data update' }}</p>
                              <p><strong>Net Salary After Edit:</strong> {{ getNetSalaryAfterEdit(selectedEdit.newData) }}</p>
                              <hr class="hr-divider">
                              <h6 class="hr-fw-semibold hr-mb-2">Changes:</h6>
                              <div class="hr-table-wrapper">
                                <table class="hr-table hr-table-bordered">
                                  <thead>
                                  <tr>
                                    <th>Field</th>
                                    <th>Previous Value</th>
                                    <th>New Value</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="field in getDetailedChanges(selectedEdit.previousData, selectedEdit.newData)" :key="field.name">
                                    <td><strong>{{ field.displayName }}</strong></td>
                                    <td class="hr-text-danger">{{ field.previousValue || '-' }}</td>
                                    <td class="hr-text-success">{{ field.newValue || '-' }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="hr-form-grid hr-mt-4" style="grid-template-columns: 1fr 1fr; gap: 1rem;" v-if="selectedEdit.approved === 'false'">
                                <button type="button" class="hr-btn hr-btn-success hr-w-100" data-bs-toggle="modal" data-bs-target="#approveModal">
                                  <i class="bx bx-check-circle"></i> Approve Changes
                                </button>
                                <button type="button" class="hr-btn hr-btn-danger hr-w-100" @click="declineChanges(selectedEdit.id)">
                                  <i class="bx bx-x-circle"></i> Decline Changes
                                </button>
                              </div>
                              <div v-else class="hr-alert hr-alert-info">
                                <i class="bx bx-info-circle"></i>
                                <span v-if="selectedEdit.approved === 'true'">
                These changes were approved by {{ selectedEdit.approvedBy }} on {{ formatDate(selectedEdit.dateApproved) }}.
              </span>
                                <span v-else-if="selectedEdit.approved === 'declined'">
                These changes were declined.
              </span>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="hr-btn hr-btn-secondary" data-bs-dismiss="modal" @click="closeModalFromEvent($event)">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
        </div>

      <!-- Approve Modal with OTP -->
      <div class="modal fade" id="approveModal" tabindex="-1" aria-labelledby="approveModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-light-blue border-success">
            <div class="modal-header text-black text-uppercase border-0">
              <h4 class="modal-title" id="approveModalLabel">Approve Edit Changes</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeAllModals(); closeModalFromEvent($event)" aria-label="Close"></button>
            </div>
            <!-- OTP Entry Section -->
            <div v-if="alert.info" class="modal-body approve-otp-entry">
              <div class="mb-3">
                <label for="approveReason" class="form-label fw-bold">Reason for Approval</label>
                <textarea class="form-control border-success" id="approveReason" rows="3" placeholder="Please enter your reason for approving these changes..."></textarea>
              </div>

              <div class="alert alert-success border-success border-2" role="alert">
                <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                <p>An OTP (One-Time Password) has been sent to your phone: <strong>+254 7XX XXX 123</strong>. Please enter the OTP to verify and approve the employee record changes.</p>

                <div class="hstack gap-3">
                  <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                  <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                </div>
              </div>

              <button @click="approveChanges(selectedEdit.id)" class="btn btn-success fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" id="confirmApproveBtn" title="Confirm Approval">
                <div>Confirm Approval</div>
                <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>

            <!-- Success Message (Initially Hidden) -->
            <div v-if="alert.success" class="modal-body approve-success">
              <div class="p-4 pb-1 px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-success mini-stat-icon">
                            <span class="avatar-title rounded-circle bg-success">
                                <i class="bx bx-check-circle fs-1"></i>
                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-dark modal-title fw-bold">Changes Approved Successfully</h4>
                <p class="text-center px-5">
                  The employee record changes have been approved successfully. The system has been updated with the new information.
                </p>
                <div class="w-100 mt-2">
                  <button type="button" data-bs-dismiss="modal" @click="closeAllModals(); closeModalFromEvent($event)" aria-label="Close" class="btn btn-outline-success waves-effect w-100 btn-close-btn text-uppercase fw-bold">
                    Close
                  </button>
                </div>
              </div>
            </div>

            <!-- show this for a failed attempt -->
            <div v-if="alert.failed" class="modal-body waiver-fail">
              <div class="p-4 pb-1  px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-danger mini-stat-icon" title="Recruitment Approval Failed">
                                            <span class="avatar-title rounded-circle bg-danger">
                                                <i class="mdi mdi-alert-circle fs-1" title="Recruitment Failed"></i>
                                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-danger modal-title fw-bold" title="Recruitment Approval Failed">Recruitment Approval Failed</h4>
                <p class="text-center px-5" title="Recruitment Failure Reason">
                  Unfortunately, the approval of this recruitment record was unsuccessful. {{message}}
                </p>

                <div class="w-100 mt-2">
                  <button type="button" class="btn btn-info waves-effect w-100 btn-close-btn text-uppercase fw-bold">Retry</button>
                  <h6 class="text-center my-2">- OR -</h6>
                  <button type="button" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close" class="btn btn-outline-secondary waves-effect w-100 btn-close-btn text-uppercase fw-bold">Close</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


      <!-- Decline Modal with OTP -->
      <div class="modal fade" id="declineModal" tabindex="-1" aria-labelledby="declineModalLabel" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-light-blue border-danger">
            <div class="modal-header text-black text-uppercase border-0">
              <h4 class="modal-title" id="declineModalLabel">Decline Edit Changes</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close"></button>
            </div>
            <!-- OTP Entry Section -->
            <div class="modal-body decline-otp-entry">
              <div class="mb-3">
                <label for="declineReason" class="form-label fw-bold">Reason for Declining</label>
                <textarea class="form-control border-danger" id="declineReason" rows="3" placeholder="Please enter your reason for declining these changes..."></textarea>
              </div>

              <div class="alert alert-danger border-danger border-2" role="alert">
                <h4 class="alert-heading text-black text-uppercase">OTP Verification</h4>
                <p>An OTP (One-Time Password) has been sent to your phone: <strong>+254 7XX XXX 123</strong>. Please enter the OTP to verify and decline the employee record changes.</p>

                <div class="hstack gap-3">
                  <input class="form-control me-auto border-black otp-input" type="text" placeholder="Enter OTP" aria-label="Enter OTP here..." spellcheck="false">
                  <button type="button" class="btn btn-warning text-dark fw-bold text-nowrap text-uppercase">Resend OTP</button>
                </div>
              </div>

              <button class="btn btn-danger fw-bold mt-4 text-uppercase w-100 d-flex justify-content-center align-items-center text-center otp-btn" id="confirmDeclineBtn" title="Confirm Decline">
                <div>Confirm Decline</div>
                <div class="spinner-border text-white ms-2 d-none" style="height: 19px; width: 19px;" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
            </div>

            <!-- Success Message (Initially Hidden) -->
            <div class="modal-body decline-success d-none">
              <div class="p-4 pb-1 px-1 d-flex align-items-center justify-content-center flex-column pt-1">
                <div class="flex-shrink-0 align-self-center mb-4">
                  <div class="avatar-md rounded-circle bg-danger mini-stat-icon">
                            <span class="avatar-title rounded-circle bg-danger">
                                <i class="bx bx-x-circle fs-1"></i>
                            </span>
                  </div>
                </div>
                <h4 class="text-uppercase text-dark modal-title fw-bold">Changes Declined Successfully</h4>
                <p class="text-center px-5">
                  The employee record changes have been declined. The original information will be retained in the system.
                </p>
                <div class="w-100 mt-2">
                  <button type="button" data-bs-dismiss="modal" @click="closeModalFromEvent($event)" aria-label="Close" class="btn btn-outline-danger waves-effect w-100 btn-close-btn text-uppercase fw-bold">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";
import { authUrl, execute } from "@/api";
export default {
  name: "EmployeeApprovalsEditApprovals",
  components: { HrPageLayout },
  data(){
    return{
      alert:{
        success: false,
        info: true,
        failed:false
      },
      currentPage: 1,
      // set the total number of pages as 10 (you can change this according to your data source)
      totalPages: 0,
      // set the number of items per page as 5 (you can change this according to your preference)
      pageSize: 10,
      employeeDataEdits: [],
      message: '',
      selectedEdit: null,
    }
  },
  mounted() {
    this.getEmployeeDataEdits()
  },
  methods:{
    gotTo(route){
      this.$router.push(route);
    },

    // Fetch employee data edits from the server
    getEmployeeDataEdits() {
      const data = new FormData();
      data.append("function", "getEmployeeDataEdits");
      execute(data, authUrl)
          .then((res) => {
            this.employeeDataEdits.splice(0)
            if (res.data.success) {

              this.employeeDataEdits = res.data.data.employeeDataEdits;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.alert.success = false;
            this.alert.info = false;
            this.alert.failed = true;
            this.message = e.message;
          });
    },

    // View details of a specific edit
    viewEditDetails(item) {
      this.selectedEdit = item;
    },

    // Function to identify changed fields between previousData and newData
    getChangedFields(previousData, newData) {
      try {
        // Parse the JSON strings to objects
        const prevObj = typeof previousData === 'string' ? JSON.parse(previousData) : previousData;
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // List of fields to monitor for changes
        const fieldsToCheck = {
          employeeData: [
            'firstName', 'lastName', 'email', 'phone', 'nationalId', 'title',
            'gender', 'physicalAddress', 'postalCode', 'city', 'country',
            'disabilityStatus', 'disabilityId', 'dob', 'drivingLicense', 'bloodGroup',
            'maritalStatus', 'spouseName'
          ],
          employmentDetails: [
            'departmentID', 'departmentName','section', 'unit', 'subunit', 'designation',
            'employmentDate', 'reportingDate', 'reportingTo', 'netSalary'
          ],
          bankDetails: [
            'accountHolder', 'accountNumber', 'bankCountry', 'bankName',
            'branchLocation', 'shifNumber', 'nssfNumber'
          ]
        };

        // Array to store changed field names
        const changedFields = [];

        // Check primary employeeData fields
        fieldsToCheck.employeeData.forEach(field => {
          if (
              (prevObj.employeeData && newObj.employeeData) &&
              prevObj.employeeData[field] !== newObj.employeeData[field]
          ) {
            changedFields.push(field);
          }
        });

        // Check employment details
        if (prevObj.employmentDetails && newObj.employmentDetails) {
          fieldsToCheck.employmentDetails.forEach(field => {
            const prevValue = prevObj.employmentDetails[field] ||
                (prevObj.employeeData ? prevObj.employeeData[field] : undefined);
            const newValue = newObj.employmentDetails[field] ||
                (newObj.employeeData ? newObj.employeeData[field] : undefined);

            if (prevValue !== newValue && !changedFields.includes(field)) {
              changedFields.push(field);
            }
          });
        }

        // Check bank details
        if (prevObj.bankDetails && newObj.bankDetails) {
          fieldsToCheck.bankDetails.forEach(field => {
            const prevValue = prevObj.bankDetails[field] ||
                (prevObj.employeeData ? prevObj.employeeData[field] : undefined);
            const newValue = newObj.bankDetails[field] ||
                (newObj.employeeData ? newObj.employeeData[field] : undefined);

            if (prevValue !== newValue && !changedFields.includes(field)) {
              changedFields.push(field);
            }
          });
        }

        // Check for changes in emergency contacts
        if (prevObj.emergencyContacts && newObj.emergencyContacts) {
          const emergencyContactsChanged = JSON.stringify(prevObj.emergencyContacts) !==
              JSON.stringify(newObj.emergencyContacts);
          if (emergencyContactsChanged) {
            changedFields.push('emergencyContacts');
          }
        }

        // Check for changes in next of kin
        if (prevObj.nextOfKin && newObj.nextOfKin) {
          const nextOfKinChanged = JSON.stringify(prevObj.nextOfKin) !==
              JSON.stringify(newObj.nextOfKin);
          if (nextOfKinChanged) {
            changedFields.push('nextOfKin');
          }
        }

        // Check for changes in documents
        if (prevObj.documents && newObj.documents) {
          const documentsChanged = JSON.stringify(prevObj.documents) !==
              JSON.stringify(newObj.documents);
          if (documentsChanged) {
            changedFields.push('documents');
          }
        }

        return changedFields;
      } catch (error) {
        console.error("Error comparing data:", error);
        return ["Error processing changes"];
      }
    },

    // Format field names for display
    formatFieldName(fieldName) {
      const specialCases = {
        'dob': 'Date of Birth',
        'nationalId': 'National ID',
        'nextOfKin': 'Next of Kin',
        'emergencyContacts': 'Emergency Contacts',
        'netSalary': 'Net Salary',
        'nssfNumber': 'NSSF Number',
        'shifNumber': 'SHIF Number'
      };

      if (specialCases[fieldName]) {
        return specialCases[fieldName];
      }

      // Add spaces before capital letters and capitalize first letter
      return fieldName
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, str => str.toUpperCase());
    },

    // Get formatted string of changed fields
    getFormattedChangedFields(previousData, newData) {
      const changedFields = this.getChangedFields(previousData, newData);

      if (changedFields.length === 0) {
        return "No changes detected";
      }

      return changedFields
          .map(field => this.formatFieldName(field))
          .join(', ');
    },

    // Format date for display
    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      return date.toLocaleString();
    },

    // Get net salary after the edit
    getNetSalaryAfterEdit(newData) {
      try {
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // Try to get net salary from various locations where it might be stored
        let netSalary = '';

        if (newObj.employeeData && newObj.employeeData.netSalary) {
          netSalary = newObj.employeeData.netSalary;
        } else if (newObj.employmentDetails && newObj.employmentDetails.netSalary) {
          netSalary = newObj.employmentDetails.netSalary;
        } else if (newObj.bankDetails && newObj.bankDetails.netSalary) {
          netSalary = newObj.bankDetails.netSalary;
        }

        // Format netSalary as currency if it's a number
        if (netSalary && !isNaN(netSalary)) {
          return `KES ${parseFloat(netSalary).toLocaleString()}`;
        }

        return netSalary || 'N/A';
      } catch (error) {
        console.error("Error getting net salary:", error);
        return 'N/A';
      }
    },

    // Get detailed changes for display in the modal
    getDetailedChanges(previousData, newData) {
      try {
        // Parse the JSON strings to objects
        const prevObj = typeof previousData === 'string' ? JSON.parse(previousData) : previousData;
        const newObj = typeof newData === 'string' ? JSON.parse(newData) : newData;

        // Track detailed changes with previous and new values
        const detailedChanges = [];

        // Helper function to add a change to the detailedChanges array
        const addChange = (field, displayName, prevValue, newValue) => {
          if (prevValue !== newValue) {
            detailedChanges.push({
              name: field,
              displayName: displayName || this.formatFieldName(field),
              previousValue: prevValue,
              newValue: newValue
            });
          }
        };

        // Structure to define which fields to check and in which objects
        const fieldsToCheck = [
          // Basic employee data
          { section: 'employeeData', fields: [
              { name: 'firstName', display: 'First Name' },
              { name: 'lastName', display: 'Last Name' },
              { name: 'email', display: 'Email' },
              { name: 'phone', display: 'Phone' },
              { name: 'nationalId', display: 'National ID' },
              { name: 'title', display: 'Title' },
              { name: 'gender', display: 'Gender' },
              { name: 'physicalAddress', display: 'Physical Address' },
              { name: 'postalCode', display: 'Postal Code' },
              { name: 'city', display: 'City' },
              { name: 'country', display: 'Country' },
              { name: 'disabilityStatus', display: 'Disability Status' },
              { name: 'disabilityId', display: 'Disability ID' },
              { name: 'dob', display: 'Date of Birth' },
              { name: 'drivingLicense', display: 'Driving License' },
              { name: 'bloodGroup', display: 'Blood Group' },
              { name: 'maritalStatus', display: 'Marital Status' },
              { name: 'spouseName', display: 'Spouse Name' }
            ]},
          // Employment details
          { section: 'employmentDetails', fields: [
              { name: 'departmentName', display: 'departmentName'},
              { name: 'departmentID', display: 'departmentID' },
              { name: 'section', display: 'Section/Sub-vote' },
              { name: 'unit', display: 'Unit/Directorate' },
              { name: 'subunit', display: 'Sub Unit' },
              { name: 'designation', display: 'Designation' },
              { name: 'employmentDate', display: 'Employment Date' },
              { name: 'reportingDate', display: 'Reporting Date' },
              { name: 'reportingTo', display: 'Reporting To' },
              { name: 'netSalary', display: 'Net Salary' }
            ]},
          // Bank details
          { section: 'bankDetails', fields: [
              { name: 'accountHolder', display: 'Account Holder Name' },
              { name: 'accountNumber', display: 'Account Number' },
              { name: 'bankCountry', display: 'Bank Country' },
              { name: 'bankName', display: 'Bank Name' },
              { name: 'branchLocation', display: 'Branch Location' },
              { name: 'shifNumber', display: 'SHIF Number' },
              { name: 'nssfNumber', display: 'NSSF Number' }
            ]}
        ];

        // Process each section and field
        fieldsToCheck.forEach(section => {
          section.fields.forEach(field => {
            let prevValue, newValue;

            // Check if the field exists in the primary section first
            if (prevObj[section.section] && newObj[section.section]) {
              prevValue = prevObj[section.section][field.name];
              newValue = newObj[section.section][field.name];
            }
            // If not found in the section, try to find it in employeeData
            else if (prevObj.employeeData && newObj.employeeData) {
              prevValue = prevObj.employeeData[field.name];
              newValue = newObj.employeeData[field.name];
            }

            // Add the change if values are different
            addChange(field.name, field.display, prevValue, newValue);
          });
        });

        // Handle emergency contacts changes
        if (prevObj.emergencyContacts && newObj.emergencyContacts) {
          // For simplicity, just check if the emergency contacts structure has changed
          const prevEmergencyContacts = JSON.stringify(prevObj.emergencyContacts);
          const newEmergencyContacts = JSON.stringify(newObj.emergencyContacts);

          if (prevEmergencyContacts !== newEmergencyContacts) {
            // Process each emergency contact to show specific changes
            const processedContacts = new Set();

            // Compare emergency contacts with matching IDs
            prevObj.emergencyContacts.forEach(prevContact => {
              const newContact = newObj.emergencyContacts.find(c => c.id === prevContact.id);
              if (newContact) {
                processedContacts.add(prevContact.id);

                // Check for changes in each field
                if (prevContact.name !== newContact.name) {
                  addChange(`emergencyContact_${prevContact.id}_name`,
                      `Emergency Contact: ${prevContact.name}`,
                      prevContact.name,
                      newContact.name);
                }

                if (prevContact.email !== newContact.email) {
                  addChange(`emergencyContact_${prevContact.id}_email`,
                      `Emergency Contact Email (${prevContact.name})`,
                      prevContact.email,
                      newContact.email);
                }

                if (prevContact.phoneNumber !== newContact.phoneNumber) {
                  addChange(`emergencyContact_${prevContact.id}_phone`,
                      `Emergency Contact Phone (${prevContact.name})`,
                      prevContact.phoneNumber,
                      newContact.phoneNumber);
                }

                if (prevContact.relationship !== newContact.relationship) {
                  addChange(`emergencyContact_${prevContact.id}_relationship`,
                      `Emergency Contact Relationship (${prevContact.name})`,
                      prevContact.relationship,
                      newContact.relationship);
                }
              }
            });

            // Add new emergency contacts
            newObj.emergencyContacts.forEach(newContact => {
              if (!prevObj.emergencyContacts.some(c => c.id === newContact.id)) {
                addChange(`emergencyContact_${newContact.id}`,
                    `New Emergency Contact`,
                    'N/A',
                    `${newContact.name} (${newContact.relationship})`);
              }
            });

            // Find removed emergency contacts
            prevObj.emergencyContacts.forEach(prevContact => {
              if (!newObj.emergencyContacts.some(c => c.id === prevContact.id)) {
                addChange(`emergencyContact_${prevContact.id}`,
                    `Removed Emergency Contact`,
                    `${prevContact.name} (${prevContact.relationship})`,
                    'N/A');
              }
            });
          }
        }

        // Handle next of kin changes similarly
        if (prevObj.nextOfKin && newObj.nextOfKin) {
          const prevNextOfKin = JSON.stringify(prevObj.nextOfKin);
          const newNextOfKin = JSON.stringify(newObj.nextOfKin);

          if (prevNextOfKin !== newNextOfKin) {
            // Process individual next of kin changes
            prevObj.nextOfKin.forEach(prevKin => {
              const newKin = newObj.nextOfKin.find(k => k.id === prevKin.id);
              if (newKin) {
                // Check for changes in each field
                if (prevKin.name !== newKin.name) {
                  addChange(`nextOfKin_${prevKin.id}_name`,
                      `Next of Kin: ${prevKin.name}`,
                      prevKin.name,
                      newKin.name);
                }

                if (prevKin.relationship !== newKin.relationship) {
                  addChange(`nextOfKin_${prevKin.id}_relationship`,
                      `Next of Kin Relationship (${prevKin.name})`,
                      prevKin.relationship,
                      newKin.relationship);
                }
              }
            });
          }
        }

        return detailedChanges;
      } catch (error) {
        console.error("Error generating detailed changes:", error);
        return [{ name: 'error', displayName: 'Error', previousValue: 'Error processing changes', newValue: error.message }];
      }
    },

    // Close all modals
    closeAllModals() {
      // Close all modals using Bootstrap's API
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });

      // Remove any lingering backdrop elements
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });

      // Fix the body by removing modal-open class and inline styles
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');
    },

    // Approve changes
    approveChanges(editId) {
      if (!confirm('Are you sure you want to approve these changes?')) {
        return;
      }



      const data = new FormData();
      data.append("function", "approveEmployeeDataEdit");
      data.append("id", editId);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {

              this.alert.success = true;
              this.alert.info = false;
              this.alert.failed = false;
              this.getEmployeeDataEdits()
           /*   this.$toast.success("Changes approved successfully");
              // Update the local data to reflect the approval
              const editIndex = this.employeeDataEdits.findIndex(edit => edit.id === editId);
              if (editIndex !== -1) {
                this.employeeDataEdits[editIndex].approved = 'true';
                this.employeeDataEdits[editIndex].approvedBy = this.currentUser;
                this.employeeDataEdits[editIndex].dateApproved = new Date().toISOString();
              }*/
              // Refresh the data

            } else {
              this.alert.success = false;
              this.alert.info = false;
              this.alert.failed = true;
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.$toast.error(e.message || "An error occurred");
          });
    },

    // Decline changes
    declineChanges(editId) {
      if (!confirm('Are you sure you want to decline these changes?')) {
        return;
      }

      const data = new FormData();
      data.append("function", "declineEmployeeDataEdit");
      data.append("id", editId);

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.$toast.success("Changes declined successfully");
              // Update the local data to reflect the decline
              const editIndex = this.employeeDataEdits.findIndex(edit => edit.id === editId);
              if (editIndex !== -1) {
                this.employeeDataEdits[editIndex].approved = 'declined';
              }
              // Refresh the data
              this.getEmployeeDataEdits();
            } else {
              this.$toast.error(res.data.message || "Failed to decline changes");
            }
          })
          .catch((e) => {
            this.$toast.error(e.message || "An error occurred");
          });

  }
}}
</script>

<style scoped>
@import "@/assets/css/hr-page-shared.css";
.hr-divider { border: 0; border-top: 1px solid #e2e8f0; margin: 1rem 0; }
.hr-fw-semibold { font-weight: 600; }
.hr-w-100 { width: 100%; }
.hr-alert { padding: 12px 16px; border-radius: 8px; }
.hr-alert-info { background: #dbeafe; border: 1px solid #3b82f6; color: #1e40af; }
</style>